var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcInvoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1084_934)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.49805C0.5 1.25703 1.71719 0.248047 3.21429 0.248047H16.7857C18.2828 0.248047 19.5 1.25703 19.5 2.49805V8.68555H0.5V2.49805ZM0.5 9.81055H19.5V15.998C19.5 17.2391 18.2828 18.248 16.7857 18.248H3.21429C1.71719 18.248 0.5 17.2391 0.5 15.998V9.81055ZM5.92857 4.74805V5.31055C5.92857 5.61992 6.23393 5.87305 6.60714 5.87305C6.98036 5.87305 7.28571 5.61992 7.28571 5.31055V4.74805H12.7143V5.31055C12.7143 5.61992 13.0196 5.87305 13.3929 5.87305C13.7661 5.87305 14.0714 5.61992 14.0714 5.31055V4.74805C14.0714 4.12578 13.465 3.62305 12.7143 3.62305H7.28571C6.53504 3.62305 5.92857 4.12578 5.92857 4.74805ZM5.92857 13.748V14.3105C5.92857 14.6199 6.23393 14.873 6.60714 14.873C6.98036 14.873 7.28571 14.6199 7.28571 14.3105V13.748H12.7143V14.3105C12.7143 14.6199 13.0196 14.873 13.3929 14.873C13.7661 14.873 14.0714 14.6199 14.0714 14.3105V13.748C14.0714 13.1258 13.465 12.623 12.7143 12.623H7.28571C6.53504 12.623 5.92857 13.1258 5.92857 13.748Z",
    fill: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcInvoice);
export default __webpack_public_path__ + "static/media/ic_invoice.615d45bdf829f476c4dcac14483db7fc.svg";
export { ForwardRef as ReactComponent };